import React, { createRef, ReactNode, useEffect, useState } from "react";
import { useLoc } from "../../hooks/useLoc";
import { monthSlugsWithOverview } from "../../services/centralStore";

import { City } from "../../templates/fragments/city";
import { Region } from "../../templates/fragments/region";
import { Resort } from "../../templates/fragments/resort";
import { PageIntro } from "../shared/page-intro";
import { Gallery } from "./gallery";
import { DestinationOverview, DestinationOverviewProps } from "./overview";
import { StatCards } from "./statcards";
import { SearchForm } from "../search/search-form";

import { AffiliateTabs } from "../afils/affiliate-tabs";
import { useWasScrolled } from "../../hooks/useWasScrolled";
import { ChartWrapper } from "./chart-wrapper";
import { Ads } from "../shared/ads";

// const ChartWrapper = React.lazy(() =>
//     import("./chart-wrapper").then((module) => ({
//         default: module.ChartWrapper
//     }))
// );

export const RegionResortContext = React.createContext<Region | Resort>(
    undefined
);

export const RegionResortCore = ({
    pageContext,
    locationJson,
    month,
    overviewProperties,
    introContent,
    introTitle
}: {
    pageContext: { slug: string; lang?: string };
    locationJson: Region | Resort | City;
    month: string;
    overviewProperties: DestinationOverviewProps;
    introContent?: ReactNode;
    introTitle?: string;
}) => {
    const weatherData = locationJson.weatherData;
    const loc = useLoc(pageContext.lang || "en");
    const monthIndex = monthSlugsWithOverview.indexOf(month);
    const chartsForText = `${loc("common.weatherChartFor")} ${
        locationJson.name
    }`;

    const viatorWrapperRef = createRef<HTMLDivElement>();
    const kiwiWrapperRef = createRef<HTMLDivElement>();
    const wasScrolled = useWasScrolled();

    useEffect(() => {
        // if (!wasScrolled) {
        //     return;
        // }
        if (
            viatorWrapperRef.current &&
            viatorWrapperRef.current.children.length === 0 &&
            (locationJson as Resort).afData?.vtId
        ) {
            // const vtId = (locationJson as Resort).afData?.vtId;
            // const script = document.createElement("script");
            // viatorWrapperRef.current.appendChild(script);
            // script.setAttribute(
            //     "src",
            //     `https://tp.media/content?currency=usd&trs=340797&shmarker=564086.2&powered_by=false&locale=en&destination=${vtId}&lowest_price=&highest_price=&min_lines=4&color_button=%23e84749&promo_id=5850&campaign_id=47`
            // );
            // script.setAttribute("async", "true");
        }
        if (
            kiwiWrapperRef.current &&
            kiwiWrapperRef.current.children.length === 0 &&
            (locationJson as Resort).afData?.airCode
        ) {
            // const airCode = (locationJson as Resort).afData?.airCode;
            // const script = document.createElement("script");
            // kiwiWrapperRef.current.appendChild(script);
            // script.setAttribute(
            //     "src",
            //     `https://tp.media/content?currency=usd&trs=340797&shmarker=564086.2&locale=en&default_destination=${airCode}&stops=any&show_hotels=false&powered_by=false&border_radius=8&plain=true&color_button=%23E84749&color_button_text=%23ffffff&promo_id=3414&campaign_id=111`
            // );
            // script.setAttribute("async", "true");
        }
    }, [
        viatorWrapperRef.current,
        kiwiWrapperRef.current,
        locationJson,
        wasScrolled
    ]);
    overviewProperties.chartsForText = chartsForText;

    // TODO locale
    return (
        <RegionResortContext.Provider value={locationJson as Region | Resort}>
            <div className={month != "climate" ? "h-12" : "h-4"}></div>
            {month != "climate" && (
                <StatCards
                    weatherData={weatherData}
                    monthIndex={monthIndex}
                ></StatCards>
            )}
            <div className="h-1"></div>
            <div
                className={`w-page-overview m-auto ${
                    introContent ? "mt-12" : "mt-6"
                }`}
            >
                <div className="h-2"></div>
                <PageIntro
                    overviewNode={
                        <DestinationOverview {...overviewProperties} />
                    }
                    introContent={introContent}
                    introTitle={introTitle}
                />
            </div>
            <Ads idx={1} />
            {/* {(locationJson as Region).afData && (
                <>
                    <h2 className="w-destination-header font-destination-header m-auto mb-6 mt-6 md:mt-16 md:mb-10">
                        Travel information
                    </h2>
                    <AffiliateTabs />
                </>
            )} */}

            <h2 className="w-destination-header font-destination-header m-auto mb-10 mt-16 md:mt-24">
                <a
                    id="weather-chart"
                    className="relative top-[-100px] md:top-[-120px]"
                />
                {chartsForText}
            </h2>
            <ChartWrapper weatherData={locationJson.weatherData} />
            <div className="h-6"></div>
            <div className="h-6"></div>
            {/* <SunheronFeatures /> */}
            <div className="h-10"></div>

            {(locationJson as Region).imgAlts && (
                <Gallery
                    imgAlts={(locationJson as Region).imgAlts}
                    galleryPhotos={(locationJson as Region).imgs.map(
                        (i) => i.childImageSharp.gatsbyImageData
                    )}
                ></Gallery>
            )}
            <div className="h-16"></div>
            <h2 className="w-destination-header font-destination-header m-auto mb-10">
                {`Find more destinations like this`}
            </h2>
            <SearchForm />

            {/* {(locationJson as Resort).afData?.vtId && (
                <>
                    <h2 className="w-destination-header font-destination-header m-auto mb-6 mt-16 md:mt-24">
                        {`Activities in ${locationJson.name}`}
                    </h2>
                    <div
                        ref={viatorWrapperRef}
                        onClick={() => {
                            if (!(locationJson as Resort).afData?.vtId) {
                                return;
                            }
                            const continent =
                                (locationJson as Resort).region?.country
                                    .continent ||
                                (locationJson as Region).country.continent;
                            window.dataLayer.push({
                                event: "afil_landing",
                                type: "activities",
                                continent,
                                subId: 2,
                                slug: (locationJson as Resort).slug
                            });
                        }}
                        className="mx-auto w-11/12 max-w-[1400px]"
                    />
                </>
            )} */}
            {/* {(locationJson as Resort).afData?.airCode && (
                <>
                    <h2 className="w-destination-header font-destination-header m-auto mb-6 mt-16 md:mt-24">
                        {`Flights to ${locationJson.name}`}
                    </h2>
                    <div
                        ref={kiwiWrapperRef}
                        onClick={() => {
                            if (!(locationJson as Resort).afData?.airCode) {
                                return;
                            }
                            const continent =
                                (locationJson as Resort).region?.country
                                    .continent ||
                                (locationJson as Region).country.continent;
                            window.dataLayer.push({
                                event: "afil_landing",
                                type: "flightTickets",
                                continent,
                                subId: 2,
                                slug: (locationJson as Resort).slug
                            });
                        }}
                        className="mx-auto w-11/12 max-w-[1400px]"
                    />
                </>
            )} */}
        </RegionResortContext.Provider>
    );
};
